import React, { Fragment } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography
} from '@mui/material'
import { ColorBoxContent } from 'common/ui/colorBox'
import { getDate } from 'helpers/date'
import PropTypes from 'prop-types'

import CloseIcon from '../../../assets/icons/circles-design/Close.png'

export default function QuotationDialog({
  isDialogOpen,
  setDialogOpen,
  checked,
  checkStatus,
  onCheckboxClick,
  handlePayment,
  quotationDetails,
  orgDetails
}) {
  return (
    <Dialog
      PaperProps={{
        style: {
          borderRadius: '7px',
          minWidth: '80%',
          maxHeight: 'calc(100vh-200px)',
          overflowY: 'auto'
        }
      }}
      open={isDialogOpen}
      onClose={() => setDialogOpen(false)}
      data-cy='quotationDialog'
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            color: '#818D9C'
          }}
        >
          <div data-cy='quotationId'>{quotationDetails?._id}</div>
        </Typography>
        <IconButton
          aria-label='close'
          onClick={() => setDialogOpen(false)}
          sx={{
            color: (_theme) => _theme.palette.grey[500]
          }}
          data-cy='closeBtn'
        >
          <img src={CloseIcon} width='24px' alt='Close Icon' />
        </IconButton>
      </DialogTitle>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '70%'
          }}
        >
          <DialogContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant='h4'>Quotation</Typography>
              <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                {getDate(quotationDetails?.createdAt)}
              </Typography>
            </Box>

            <Divider sx={{ width: '100%' }} />
            <Box
              sx={{
                height: '470px'
              }}
            >
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr data-align='left'>
                    <th style={{ width: '40%' }}>Order Summary</th>
                    <th style={{ width: '30%' }}>Price</th>
                    <th style={{ width: '30%' }}>Quantity</th>
                    <th style={{ width: '30%' }}>Amount</th>
                  </tr>
                  <Divider sx={{ width: '280%' }} />
                  {quotationDetails &&
                    quotationDetails.items?.map((item, index) => {
                      return (
                        <tr
                          key={`${item.name}-${index}`}
                          className='spaceUnder'
                        >
                          <Box>
                            <td style={{ width: '45%' }}>
                              {item.name}
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  color: '#818D9C'
                                }}
                              >
                                {item.desc}
                              </Typography>
                            </td>
                          </Box>
                          <td style={{ width: '25%' }}>${item.price}</td>
                          <td style={{ width: '25%' }}>{item.quantity}</td>
                          <td style={{ width: '25%' }}>
                            ${item.price * item.quantity}
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>
            </Box>
          </DialogContent>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '30%'
          }}
        >
          <DialogContent>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between'
              }}
            >
              <Typography variant='h4'>Prepared for:</Typography>
            </Box>
            <Divider sx={{ width: '100%' }} />
            <table>
              {[
                { label: 'Company Name', field: orgDetails.name },
                {
                  label: 'Unique Entity Number (UEN)',
                  field: orgDetails.uen
                },
                {
                  label: "Contact Person's Name",
                  field: quotationDetails?.user[0]?.name
                },
                {
                  label: 'Contact Number',
                  field: `+65${quotationDetails?.user[0]?.contactNumber}`
                },
                { label: 'Email', field: quotationDetails?.user[0]?.email },
                {
                  label: 'Delivery Address',
                  field: orgDetails.deliveryAddress
                },
                {
                  label: 'Billing Address',
                  field: orgDetails.billingAddress
                }
              ].map(({ label, field }) => {
                return (
                  <Fragment key={label}>
                    <tr data-align='left'>
                      <Typography sx={{ fontSize: '14px', color: '#818D9C' }}>
                        {label}
                      </Typography>
                    </tr>
                    <tr>
                      <td>{field}</td>
                    </tr>
                  </Fragment>
                )
              })}
            </table>
          </DialogContent>
        </Box>
      </Box>

      <br />
      <Box height='50px'>
        <Box>
          <ColorBoxContent
            variant='primary'
            style={{
              padding: '20px',
              width: '660px',
              minHeight: '37px',
              margin: '20px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <table style={{ width: '100%' }}>
              <tr>
                <th>
                  <Typography
                    align='left'
                    variant='h6'
                    sx={{ fontSize: '14px', color: '#818D9C' }}
                  >
                    Validity:
                    {getDate(quotationDetails?.expiryAt)}
                  </Typography>
                </th>
                <th align='right'>Total: ${quotationDetails?.price}</th>
              </tr>
            </table>
          </ColorBoxContent>

          <ColorBoxContent
            variant='primary'
            style={{
              padding: '20px',
              width: '660px',
              minHeight: '196px',
              margin: '20px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            Terms & Conditions
            <Typography variant='subtitle1' sx={{ marginBottom: '24px' }}>
              Terms & Conditions Lorem ipsum dolor sit amet, consectetur
              adipiscing elit. Sed facilisis posuere massa, lobortis placerat
              est accumsan eget. Aliquam aliquet dui nec dui maximus
              sollicitudin vel sit amet diam. Curabitur vestibulum pretium
              aliquet. In aliquet urna lectus, non dapibus nulla eleifend ut.
              Pellentesque quis velit nisl. Morbi tristique, ligula in fermentum
              mollis, enim velit gravida quam, elementum tristique enim nisi et
              lacus. Proin eu ligula ut nisl dignissim posuere. Ut rutrum a
            </Typography>
            <Divider sx={{ width: '100%' }} />
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Checkbox
                checked={checkStatus ? !checked : checked}
                onChange={(e) => onCheckboxClick(e)}
                sx={{ color: '#CFD8E3' }}
              />
              I agree and accept the quotation price
            </Box>
          </ColorBoxContent>
        </Box>
        <Box>
          <DialogActions>
            <Button
              variant='contained'
              disabled={!checked}
              onClick={handlePayment}
            >
              Proceed to Payment
            </Button>
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  )
}

QuotationDialog.propTypes = {
  isDialogOpen: PropTypes.bool,
  setDialogOpen: PropTypes.func,
  checked: PropTypes.bool,
  checkStatus: PropTypes.bool,
  onCheckboxClick: PropTypes.func,
  handlePayment: PropTypes.func,
  quotationDetails: PropTypes.object,
  orgDetails: PropTypes.object
}
